import _toConsumableArray from "/opt/build/repo/web/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _defineProperty from "/opt/build/repo/web/node_modules/@babel/runtime/helpers/esm/defineProperty.js";

/** ******************************************************
 * FORM - State file.
 * Contains everything related to form state such as the reducer and action factories.
 ******************************************************* */
import { Objects } from '../../utils/objects';
/**
 * The reducer for the form state object
 * @param state The current form state.
 * @param action The action to respond to.
 * @returns The updated state.
 */

export function dataReducer(state, action) {
  switch (action.type) {
    case 'set-one':
      return Array.isArray(state) || Number.isInteger(action.propertyKey) ? (state || []).map(function (_, i) {
        return i === action.propertyKey ? action.value : state[i];
      }) : Object.assign(Object.assign({}, state || {}), _defineProperty({}, action.propertyKey, action.value));

    case 'set-path':
      return Objects.mergeDeepFromKeyChain(state, action.keyChain, action.value);

    case 'set-all':
      return Array.isArray(action.data) ? _toConsumableArray(action.data) : Object.assign({}, action.data);

    default:
      return state;
  }
}
export function validationReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var action = arguments.length > 1 ? arguments[1] : undefined;

  var _a;

  switch (action.type) {
    case 'add-validation':
      return [].concat(_toConsumableArray(state), _toConsumableArray((_a = action.errors) !== null && _a !== void 0 ? _a : []));

    case 'clear-validation':
      var validationToClear = state.filter(function (e) {
        var _a, _b;

        if (!action.key && !((_a = action.identifiers) === null || _a === void 0 ? void 0 : _a.length)) {
          return true;
        }

        return action.key === e.key && (!((_b = action.identifiers) === null || _b === void 0 ? void 0 : _b.length) || action.identifiers.some(function (id) {
          return id === e.identifier;
        }));
      });
      return state.filter(function (e) {
        return !validationToClear.some(function (c) {
          return c === e;
        });
      });

    default:
      return state;
  }
}